import { type ApiClientResponse, apiClient, routes } from 'common/services';

type P = {
  changeRequests: Array<{
    change_request: {
      kind: string;
      meta?: { invitation_email?: string; invitation_phone?: string };
      subject_id: string;
      subject_type: string;
      subject_user_id?: string;
    };
  }>;
};

export const inviteUsersToCommunity = async ({ changeRequests }: P) =>
  apiClient.post<undefined, ApiClientResponse<undefined>>(routes.community.inviteUsers, changeRequests);
